import ReportBoard from "./ReportBoard";
import { Image } from "antd";
import { Skeleton } from "antd";

export default function ReportRevenueBoard({
  summaryData = null,
  data=null,
  context = "",
  handleDownload=()=>{},
  showDownloadBtn = true,
}) {
  return (
    <section>
      <div
        className={`flex items-center ${
          context === "item-wise-sales" ? "justify-end" : "justify-between"
        } flex-wrap space-x-[20px]`}
      >
        {/* revenue-report */}
        {context !== "item-wise-sales" && (
          <div className="flex flex-wrap items-start gap-y-3">
            {summaryData == null || Object.keys(summaryData).length < 1
              ? new Array(4)
                  .fill(null)
                  .map((_, i) => <Skeleton.Node key={i} active={true} style={{ width: "210px", height: "80px", marginRight: '20px' }} />)
              : Object.values(summaryData).map((summary, index) => {
                  return (
                    <div key={index} className="mr-[20px]">
                      <ReportBoard title={summary.title} amount={summary.amount || 0} context={context} />
                    </div>
                  );
                })}
          </div>
        )}

        {/* actions */}
        {showDownloadBtn && (
          <div className="flex space-x-[10px]">
            <button onClick={handleDownload}>
              <Image src="/images/icons/download.svg" preview={false} alt="download-report" />
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
